export function isNotFoundError(error) {
  return Boolean(error?.response?.status === 404);
}
